import { Autocomplete, TextField } from "@mui/material"
import { useState } from "react"
import { FilterProps } from "./Filters/Filter"
import { SelectorProps } from "../Selector"

interface AutocompleteSelectorProps extends SelectorProps {
  onDataChange: (newValue: any | null) => void
  getOptionLabel: (option: any) => string
  isOptionEqualToValue: (option: any, value: any) => boolean
}

const AutocompleteSelector: React.FC<AutocompleteSelectorProps & FilterProps> = (props) => {
  const [InputValue, setInputValue] = useState('')
  
  return (<Autocomplete
    style={{ ...props.style }}
    key={props.name}
    id={props.name}
    value={props.value === undefined ? null : props.value}
    inputValue={InputValue}
    onChange={(event: any, newValue: any | null) => {
      props.onDataChange(newValue)
    }}
    onInputChange={(event, newInputValue) => {
      setInputValue(newInputValue)
    }}
    options={props.menuItems!}
    disabled={props.disabled}
    getOptionLabel={props.getOptionLabel}
    isOptionEqualToValue={props.isOptionEqualToValue}
    renderInput={(params) => <TextField {...params}  label={props.label} error={props.error} helperText={props.helperText} required={props.required} disabled={props.disabled}/>}
  />

  )
}

export default AutocompleteSelector